import { ReactComponent as LeftIcon } from 'assets/icons/chevronLeft16.svg'
import { ReactComponent as RightIcon } from 'assets/icons/chevronRight16.svg'
import { useGlobalEvent } from 'beautiful-react-hooks'
import { useStateRef } from 'hooks/useStateRef'
import { MouseEvent } from 'react'
import styles from './Carousel.module.scss'

type CarouselProps = {
  activeIndex: number
  afterChange?: (currentSlide: number) => void
  children: React.ReactNode
  slideCount: number
}

// TODO: determine size programmatically
const carouselItemWidth = 543

export const Carousel = ({ activeIndex, afterChange, children, slideCount }: CarouselProps) => {
  const [currentIndex, setCurrentIndex, _currentIndex] = useStateRef(activeIndex)

  const keydownHandler = (event: KeyboardEvent) => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault()
      if (event.key === 'ArrowLeft') prev()
      if (event.key === 'ArrowRight') next()
    }
  }

  useGlobalEvent('keydown', { capture: true }, keydownHandler)

  const next = (event?: MouseEvent) => {
    event?.preventDefault()
    if (_currentIndex.current < slideCount - 1) {
      setCurrentIndex((prevState) => prevState + 1)
      if (afterChange) afterChange(_currentIndex.current + 1)
    } else {
      setCurrentIndex(0)
      if (afterChange) afterChange(0)
    }
  }

  const prev = (event?: MouseEvent) => {
    event?.preventDefault()
    if (_currentIndex.current > 0) {
      setCurrentIndex((prevState) => prevState - 1)
      if (afterChange) afterChange(_currentIndex.current - 1)
    } else {
      setCurrentIndex(slideCount - 1)
      if (afterChange) afterChange(slideCount - 1)
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <button className={styles.prev} data-testid="prevSlide" onClick={prev}>
          <LeftIcon />
        </button>
        <div className={styles.contentWrapper}>
          <div
            data-testid="carouselContent"
            className={styles.content}
            style={{ transform: `translateX(-${currentIndex * carouselItemWidth}px)` }}
          >
            {children}
          </div>
        </div>
        <button className={styles.next} data-testid="nextSlide" onClick={next}>
          <RightIcon />
        </button>
      </div>
    </div>
  )
}
